import type { NativeEmbed } from "./shown";

/**
 * The early paint signal (SDK-PRELOAD.md 2.3): an inline script right after the server-rendered
 * chat. It leaves the `hephon:skeleton` mark that `timing.firstPaint` reads and posts `painted`
 * to the native host, which hides its spinner then instead of at page load. Plain ES5 in a
 * string: it waits for no module script, and no bundler may touch it.
 *
 * Two animation frames mean the markup above was presented. A hidden document gets no frames
 * (a preloaded web view), so a timer posts it then: nothing is covering a chat nobody sees.
 */

/** How the script reaches each host; the same choice as `transport` in bridge.ts. */
const SEND: Record<NativeEmbed, string> = {
	flutter:
		'var f=window.flutter_inappwebview,c=window.HephonBridge;if(f&&f.callHandler){var p=f.callHandler("HephonBridge",m);p&&p.catch&&p.catch(function(){})}else if(c){c.postMessage(m)}',
	android: "window.HephonBridge.postMessage(m)",
	"react-native": "window.ReactNativeWebView.postMessage(m)",
	ios: "window.webkit.messageHandlers.HephonBridge.postMessage(m)",
};

export const SKELETON_MARK = "hephon:skeleton";
/** Waits this long for the frames before posting without them. */
const NO_FRAME_MS = 60;

export function paintedScript(embed: NativeEmbed): string {
	return (
		"(function(){" +
		`performance.mark("${SKELETON_MARK}");` +
		"var done=false;" +
		"function painted(){" +
		"if(done)return;done=true;" +
		// One id per document: a host that sees it twice knows it is the same paint.
		'var m=JSON.stringify({v:1,id:"painted:"+Math.round(performance.timeOrigin),type:"painted",ts:Date.now(),data:{}});' +
		// No host object (the page opened outside its app): nothing to tell.
		`try{${SEND[embed]}}catch(e){}` +
		"}" +
		"requestAnimationFrame(function(){requestAnimationFrame(painted)});" +
		`setTimeout(painted,${NO_FRAME_MS});` +
		"})()"
	);
}
